module.exports = __webpack_public_path__ + "img/send-offer-button-desktop-fr.f400eb1c.jpg";